<template>
	<div>
		<div class="row row-eq-height prizes__list">
			<div
			class="col-md-6 col-lg-3 prizes__col"
			v-for="prize in prizes"
			:key="prize.id"
			>

				<div class="prizes__item">

					<div v-bind:class="(prize.withdrawed_from_offer == 0) ? 'prizes__item-img' : 'prizes__item-img-faded'">
						<div class="prize-withdrawed-svg" v-if="prize.withdrawed_from_offer == 1">
							<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g id="no-entry">
									<path
									id="Polygon"
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M21.3333 4L28 10.6667V21.3333L21.3333 28H10.6667L4 21.3333L4 10.6667L10.6667 4L21.3333 4Z"
									fill="#FAFAFA"
									stroke="#888888"
									/>
									<path
									id="Path 8"
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M21.3335 13.3333C22.0699 13.3333 22.6668 13.9302 22.6668 14.6666V17.3333C22.6668 18.0696 22.0699 18.6666 21.3335 18.6666H10.6668C9.93045 18.6666 9.3335 18.0696 9.3335 17.3333V14.6666C9.3335 13.9302 9.93045 13.3333 10.6668 13.3333L21.3335 13.3333Z"
									fill="#FAFAFA"
									stroke="#888888"
									/>
								</g>
							</svg>
						</div>
						<img
						v-if="prize.photo_id > 0"
						v-auth-image="'/photos/'+ prize.photo_id + '?thumbnail=300'"
						alt
						/>
					</div>

					<div class="prizes__item-desc">
						<p>{{ prize.name }}</p>

						<div class="prizes__item-footer">
							<div v-if="prize.withdrawed_from_offer == 1"
								class="button button--small button--dark prizes__item-button"
								>Wycofany z oferty</div>
							<div v-else="prize.withdrawed_from_offer == 0">
								<div v-if="prize.display_points_remaining">
									<div
										v-if="(parseFloat(prize.value) > parseFloat(user.total_points))"
										class="prizes__item-points prizes__item-points--left"
										>
										Brakuje Ci jeszcze tylko
										<b>{{ Math.ceil(parseFloat(prize.value) - parseFloat(user.total_points)) | point }} pkt</b>
									</div>
									<div
										v-else
										class="prizes__item-points prizes__item-points--complete"
										>Masz wystarczającą ilość punktów na tę nagrodę!
									</div>
									<b-progress
									v-bind:class="(parseFloat(prize.value) > parseFloat(user.total_points)) ? 'mb-3 progress-left' : 'mb-3 progress-complete'"
									:value="parseFloat(user.total_points)*100"
									:max="parseFloat(prize.value)*100"
									></b-progress>
								</div>
								<p>
									<b>
										<span>{{ parseFloat(prize.value) | point }} pkt</span>
									</b>
								</p>

								<div v-if="!user.is_invoiced">
									<button
									id="show-modal"
									@click="show('uninvoiced-user-modal')"
									class="button button--small button--azure prizes__item-button prizes__item-button--small"
									>Brak dostępu</button>
								</div>	
								<div v-else>
									<router-link
									v-if="!prize.cert_only || user.is_certyficated"
									:to="{name: 'Prize', params: { id: prize.id }}"
									class="button button--small button--blue prizes__item-button"
									>Zamów &raquo;</router-link>
									<button
									v-else
									id="show-modal"
									@click="show('uncertified-user-modal')"
									class="button button--small button--azure prizes__item-button prizes__item-button--small"
									>Wymaga certyfikatu</button>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="uncertified-user-modal">
			<modal name="uncertified-user-modal">
				<div class="row h-100">
					<span @click="hide('uncertified-user-modal')" class="prize__close"></span>
					<div class="col-md-5 d-flex justify-content-center align-items-center uncertified-user-modal__img" >
						<img class src="../../../assets/img/certify_badge_image.png" />
					</div>
					<div class="col-md-7 d-flex justify-content-center align-items-center uncertified-user-modal__desc">
						<div>
							<h2><strong>Brak certyfikacji</strong></h2>
							<p>Nie możesz wymienać punktów na nagrody, bo nie jesteś certyfikowanym użytkownikiem</p>
							<router-link
							:to="{name: 'Rules'}"
							tag="button"
							class="button button--small button--filled-blue prizes__item-button prizes__item-button--wide"
							>Sprawdź jak nim zostać &raquo;</router-link>
						</div>
					</div>
				</div>
			</modal>

			<modal name="uninvoiced-user-modal">
				<div class="row h-100">
					<span @click="hide('uninvoiced-user-modal')" class="prize__close"></span>
					<div class="col-md-1 d-flex justify-content-center align-items-center uncertified-user-modal__img" >
					</div>
					<div class="col-md-10 d-flex justify-content-center align-items-center uncertified-user-modal__desc">
						<div>
							<h2><strong>Zarejestruj pierwszą fakturę</strong></h2>
							<p>Dodaj swoją pierwszą fakturę i poczekaj na jej pozytywną weryfikację, aby móc korzystać z nagród Geberit.</p>
							<router-link
							:to="{name: 'InvoicesAdd'}"
							tag="button"
							class="button button--small button--filled-blue prizes__item-button prizes__item-button--wide"
							>Dodaj pierwszą fakturę &raquo;</router-link>
						</div>
					</div>
				</div>
			</modal>
		</div>
	</div>
</template>
<script>
import Vue from 'vue'
import { store } from '@/app/store'
import Vue2Filters from "vue2-filters";

export default {
	name: 'PrizesListComponent',
	props: [
		'prizes',
		'pagination'
	],
	mixins: [Vue2Filters.mixin],
	computed: {
		user() {
			return this.$store.state.user
		}
	},
	data () {
		return {

		}
	},
	methods: {

		/**
		* On change paginate event.
		*
		* @param  {int} page
		* @return void
		*/
		onChangePaginate(page) {
			let vm = this;

			vm.pagination.pending = true;

			Vue.axios({
				method: "get",
				url: "/prizes",
				params: {
					page: page
				}
			})
			.then(response => {
				vm.prizes = response.data.data.prizes;
				vm.pagination = response.data.pagination;
			})
			.catch(error => (vm.pagination.pending = false));
		},

		show(el) {
			this.$modal.show(el);
		},
		hide(el) {
			this.$modal.hide(el);
		}
	}

}
</script>


// WEBPACK FOOTER //
// src/app/home/prizes/PrizesListComponent.vue